






















































































































































































































































































































































































import { ApiErrorType, FeatureType } from "@/enums";
import { Campaign } from "@/types";
import { Portal, PortalInformation, PortalPanel, PortalPanelType, PortalSearchOptions } from "@/types/portal";
import { SimpleListItem } from "@/types/simpleListItem";
import * as UAS from "@/userapplicationstate";
import Utils, { PerformanceMeasurement } from "@/utils";
import { Controllers, NewsArticle, PortalHyperlink, settingName } from "@infoland/iprova-api";
import Vue from "vue";
import Alert from "../components/alerts/alert.vue";
import SearchComponent from "../components/generic/SearchComponent.vue";
import SimpleList from "../components/generic/SimpleList.vue";
import ManageFavorites from "../components/modules/favorites/ManageFavorites.vue";
import NewArticleCreateEdit from "../components/modules/newsArticle/CreateEdit.vue";
import NewsArticleList from "../components/modules/newsArticle/NewsArticleList.vue";
import NewsArticleRead from "../components/modules/newsArticle/Read.vue";
import PortalNavButtonsArea from "../components/modules/portal/PortalNavButtonsArea.vue";
import Toolbar from "../components/toolbar/Toolbar.vue";
import { getPortalForUserWithRedirectAsync } from "../portals/index";
import Shared from "../shared";
import storeHelper from "../store/store-helper";
import { NewsArticleRequest } from "../types/newsArticles-request";
import { CampaignPagingDto } from "@/api/CampaignPagingDto";

export default Vue.extend({
    name: "Portal",
    components: {
        PortalNavButtonsArea,
        NewsArticleList,
        NewsArticleRead,
        NewArticleCreateEdit,
        SimpleList,
        ManageFavorites,
        SearchComponent,
        Toolbar,
        Alert
    },
    props: {
        portalId: Number
    },
    data: function () {
        return {
            portalInformation: {} as PortalInformation,
            portalHyperlinks: {} as PortalHyperlink[],
            newsArticles: [] as NewsArticle[],
            campaigns: [] as Campaign[],
            hasCampaigns: false as boolean,
            showCreateDialog: false,
            showReadDialog: false,
            showManageFavorites: false,
            articleId: 0,
            favItems: null,
            recentContentItems: null,
            portalInformationText: null,
            currentBackgroundImageBase64: null,
            currentPreviewBackground: "0",
            hasContentItems: false as boolean,
            hasFillableContentItems: false,
            hasManagementInfoItems: null as boolean,
            portal: null as Portal,
            errorType: null as ApiErrorType,
            showError: null as Boolean,
            expandFavoritesPanel: 0,
            expandRecentPanel: 0,
            PortalPanelType: PortalPanelType,
            standardPanelText: null as string,
            standardPanelText2: null as string,
            features: []
        };
    },
    computed: {
        portalNotFound(): boolean {
            return !this.portal;
        },
        isAnonymousUser(): boolean {
            return Utils.isAnonymousUser(this.$user.user_id);
        },
        portalInformationTitle(): string {
            return this.portalInformation.title;
        },
        importantLinks(): Array<SimpleListItem> {
            return this.portalHyperlinks.map(item => {
                return {
                    id: item.hyperlink.hyperlink_id,
                    title: item.description,
                    href: this.getContentItemRedirectHref(item.hyperlink.hyperlink_id),
                    target: "_blank",
                    opener: true
                };
            });
        },
        campaignLinks(): Array<SimpleListItem> {
            //show the campaigns sorted by number of unread posts and then by title alphabetically
            return this.campaigns
                .map(x => {
                    return {
                        id: x.campaign_id,
                        title: x.subject,
                        href: `${Shared.iProvaUrl}/campaign#/${x.my_participant_key}`,
                        target: "_blank",
                        numberOfUnreadPosts: x.number_of_posts - x.number_of_completed_posts
                    };
                })
                .sort((a, b) => {
                    if (a.numberOfUnreadPosts > b.numberOfUnreadPosts) return -1;
                    if (a.numberOfUnreadPosts < b.numberOfUnreadPosts) return 1;
                    if (a.title < b.title) return -1;
                    if (a.title > b.title) return 1;
                    return 0;
                });
        },
        showUserSpecificPanels(): boolean {
            return this.$user.show_user_specific_panels;
        },
        showInformationPanel(): boolean {
            return this.portalInformationText || (this.portalInformation && this.portalInformation.image);
        },
        getLogoPosition(): string {
            switch (this.portalInformation.image_position) {
                case 1:
                    return "imageDivStart";
                case 2:
                    return "imageDivCenter";
                case 3:
                    return "imageDivEnd";
                default:
                    return "";
            }
        },
        searchScope(): string {
            if (this.searchMode == "hybrid" || this.searchMode == "modern") return "ai";
            return this.hasContentItems ? "portal" : "global";
        },
        searchMode(): "legacy" | "modern" | "hybrid" {
            const searchModeLegacy = this.features.find(f => f.name == FeatureType.search_mode_legacy)?.enabled ?? false;
            const searchModeModern = this.features.find(f => f.name == FeatureType.search_mode_modern)?.enabled ?? false;
            const searchModeHybrid = searchModeLegacy && searchModeModern;

            if (searchModeHybrid) return "hybrid";
            else if (searchModeModern) return "modern";
            return "legacy";
        }
    },
    updated() {
        setTimeout(() => {
            this.redrawMasonry();
        }, 265);
    },
    beforeMount() {
        this.loadFeatures();
    },
    async mounted() {
        this.$emit("has-panels", true);
    },
    beforeDestroy() {},
    methods: {
        async init() {
            let performanceMeasurement = PerformanceMeasurement.Start();

            const result = await getPortalForUserWithRedirectAsync(this.portalId, this.$user.user_id, window.location.href, true, true, true);
            this.portal = result.portal;
            this.errorType = result.errorType;
            this.showError = result.showError;

            let promises = [];
            promises.push(this.calculateHasItemsFlags());

            if (this.portalNotFound) {
                //portal does not exists  (or user is not authorized)
                return;
            }

            document.title = Utils.getPageTitle(this.portal.name, "after");
            this.setBackgroundImage();

            if (this.portal.panels?.some(x => x.type == PortalPanelType.Campaigns)) {
                //Check if the user has campaigns, do this before loading the campaigns
                Controllers.GenericController.getAsync<CampaignPagingDto>(
                    "campaigns?envelope=true&limit=0&include_total=true&archived=false&is_invited_participant=true&is_subscribed_participant=true&has_posts=true"
                ).then(x => {
                    this.hasCampaigns = x.pagination.total > 0;
                });
                //Load the campaigns
                promises.push(
                    Controllers.GenericController.getAsync<Campaign[]>(
                        "campaigns?archived=false&is_invited_participant=true&is_subscribed_participant=true&include_my_participant_key=true&has_posts=true&include_number_of_posts=true&include_number_of_completed_posts=true"
                    ).then(x => {
                        this.hasCampaigns = x.length > 0; //If for some reason this call is faster than the call above, we need to set the flag here as well
                        this.campaigns = x;
                    })
                );
            }

            const portalPatch = {
                portal_id: this.portalId,
                last_visited_date_time: new Date().toAPIDateTimeString()
            };
            storeHelper.portalStore.savePortal(portalPatch.portal_id, portalPatch as Portal);
            promises.push(
                storeHelper.portalInformationStore.loadPortalInformation(this.portalId).then(portalInformation => {
                    this.portalInformation = portalInformation;
                })
            );
            promises.push(
                storeHelper.portalHyperlinksStore.loadPortalHyperlinks(this.portalId).then(portalHyperlinks => {
                    this.portalHyperlinks = portalHyperlinks;
                })
            );

            promises.push(this.loadNewsArticleList());

            if (this.showUserSpecificPanels) {
                let recentPromise = storeHelper.contentItemsStore.loadRecentContentItemsAsync(null, null).then(x => {
                    this.setRecentContentItems();
                });
                let favoritePromise = storeHelper.favoriteItemsStore.loadFavorites().then(x => {
                    this.setFavoriteItems();
                });
                let uasRecentPromise;
                let uasFavoritesPromise;
                if (storeHelper.portalStore.expandRecentPanel == null) {
                    uasRecentPromise = UAS.get("expandRecentPanel").then(x => {
                        this.expandRecentPanel = Number(x) || 0;
                        storeHelper.portalStore.setExpandRecentPanel(this.expandRecentPanel == 0 ? true : false);
                    });
                } else {
                    this.expandRecentPanel = storeHelper.portalStore.expandRecentPanel ? 0 : -1;
                }

                if (storeHelper.portalStore.expandFavoritesPanel == null) {
                    uasFavoritesPromise = UAS.get("expandFavoritesPanel").then(x => {
                        this.expandFavoritesPanel = Number(x) || 0;
                        storeHelper.portalStore.setExpandFavoritesPanel(this.expandFavoritesPanel == 0 ? true : false);
                    });
                } else {
                    this.expandFavoritesPanel = storeHelper.portalStore.expandFavoritesPanel ? 0 : -1;
                }

                await Promise.all([recentPromise, favoritePromise, uasRecentPromise, uasFavoritesPromise]);
            }

            await Promise.all(promises);
            performanceMeasurement.Stop("Load Duration - Portal", { portal_id: this.portalId });
        },
        onResize() {
            this.redrawMasonry();
        },
        redrawMasonry() {
            (this as any).$redrawVueMasonry();
        },
        doSearch(options: PortalSearchOptions) {
            //go to a different page if the scope is AI
            if (options.scope === "ai") {
                this.$router.push({
                    name: "AISearch",
                    params: { portalId: this.portalId.toString() },
                    query: { searchText: options.text }
                });
            }
            //leave default search as it is
            else {
                this.$router.push({
                    name: "Search",
                    params: { portalId: this.portalId.toString() },
                    query: { searchText: options.text, scope: options.scope }
                });
            }
        },
        redirectToSpecificUrl(specificPath: string) {
            specificPath = this.$t(specificPath).toString();
            location.href = `${Shared.iProvaUrl}/${this.$t("routes.portal")}/${this.portal.name.replace(/[^a-zA-Z0-9-_]/g, "_")}/${specificPath}`;
        },

        openCreateDialog(id: number) {
            this.articleId = id;
            this.showCreateDialog = true;
        },
        openReadDialog(id: number) {
            this.articleId = id;
            this.showReadDialog = true;
        },
        closeNewsArticleDialog(isCreate: boolean) {
            if (isCreate) {
                this.showCreateDialog = false;
            } else {
                this.showReadDialog = false;
            }
            this.loadNewsArticleList();
        },
        openManageFavoritesDialog() {
            this.showManageFavorites = true;
        },
        async loadNewsArticleList() {
            const daysSetting = await storeHelper.settingsStore.getSettingAsync<number>(settingName.max_days_old_news_articles);
            const dateSince = new Date();
            dateSince.setHours(0, 0, 0, 0);
            dateSince.setDate(dateSince.getDate() - parseInt(daysSetting.toString()));
            const requestModel: NewsArticleRequest = {
                PortalId: this.portalId,
                IncludeContentItems: true,
                CreatedOnSince: dateSince
            };
            this.newsArticles = await storeHelper.newsArticleStore.loadNewsArticlesByPortal(requestModel);
        },
        redirectToContent(item) {
            const currentItem = storeHelper.contentItemsStore.currentRecentContentItems.find(rci => rci.content_item_id == item.id);
            Utils.openContentItem(currentItem, this.$router, this.portalId);
        },
        setRecentContentItems() {
            let items: SimpleListItem[] = [];
            if (storeHelper.contentItemsStore.currentRecentContentItems && storeHelper.contentItemsStore.currentRecentContentItems.length > 0) {
                const rcItems = storeHelper.contentItemsStore.currentRecentContentItems;
                items = rcItems.map(rcItem => ({
                    id: rcItem.content_item_id,
                    title: rcItem.title,
                    description: rcItem.summary,
                    href: Utils.getContentItemUrl(rcItem, this.portalId),
                    target: "_self"
                }));
            }
            this.recentContentItems = items;
        },
        setFavoriteItems() {
            let items: SimpleListItem[] = [];
            if (storeHelper.favoriteItemsStore.currentFavorites && storeHelper.favoriteItemsStore.currentFavorites.length > 0) {
                const rcItems = storeHelper.favoriteItemsStore.currentFavorites;
                //the id will be hyperlink id because the hyperlink id is used for redirect route
                items = rcItems.map(rcItem => ({
                    id: rcItem.hyperlink.hyperlink_id,
                    title: rcItem.description,
                    href: this.getContentItemRedirectHref(rcItem.hyperlink.hyperlink_id),
                    target: "_blank",
                    opener: true
                }));
            }
            this.favItems = items;
        },
        getContentItemRedirectHref(hyperlinkId: string) {
            return Shared.iProvaUrl + `/HyperlinkLoader.aspx?HyperlinkID=${hyperlinkId}&new=1`;
        },
        redirectToFavorite(item) {
            this.$router.push({ name: "hyperlink", params: { hyperlink_id: item.id, new_tab: "false" } });
        },
        async getAutoCompleteItems(val: string) {
            return await storeHelper.suggestionsStore.getSearchSuggestions(this.portal.portal_id, val);
        },
        getStandardLinks(panel: PortalPanel) {
            return panel.items
                .filter(item => item.reference_id !== null && item.reference_id !== undefined)
                .map(item => {
                    return {
                        id: item.reference_id,
                        title: item.text,
                        href: this.getContentItemRedirectHref(item.reference_id),
                        target: "_blank",
                        opener: true
                    };
                });
        },
        getStandardPanelTextOrder(panel: PortalPanel): number {
            var textItem = panel.items.find(item => item.reference_id === null || item.reference_id === undefined);
            if (textItem) {
                return textItem.order;
            }
            return -1;
        },
        getStandardPanelText(panel: PortalPanel): string {
            var textItem = panel.items.find(item => item.reference_id === null || item.reference_id === undefined);
            if (textItem) {
                return textItem.text.replace(/href=".*?hyperlinkloader.aspx\?hyperlinkid=(.{36})"([^>]*>)/gi, function (match, $1, $2) {
                    return 'href="#/hyperlink/' + $1 + '"' + $2;
                });
            }
            return "";
        },
        setBackgroundImage: function () {
            // portal preview needs to show its own background
            if (window.location.href.indexOf("?") > -1) {
                const backgroundExp: RegExp = /\?BackGroundImageID=(\d+)/;
                const portalBackgroundResult: RegExpExecArray = backgroundExp.exec(window.location.href);

                if (portalBackgroundResult) {
                    if (this.currentPreviewBackground != portalBackgroundResult[1]) {
                        const backgroundUrl: string = `url(${Shared.iProvaUrl}/portal/_background_bgi_${portalBackgroundResult[1]}/themebackground.jpg)`;
                        document.getElementById("portalBackground").style.backgroundImage = backgroundUrl;
                        document.getElementById("portalBackground").style.backgroundRepeat = "repeat";
                        this.currentPreviewBackground = portalBackgroundResult[1];
                    }
                    return;
                }
            }

            if (this.portal?.background_image_base64 && this.currentBackgroundImageBase64 != this.portal?.background_image_base64) {
                this.currentBackgroundImageBase64 = this.portal.background_image_base64;
                const backgroundUrl: string = "url(data:image/png;base64," + this.portal?.background_image_base64 + ")";

                document.getElementById("portalBackground").style.backgroundImage = backgroundUrl;
                document.getElementById("portalBackground").style.backgroundRepeat = "repeat";
            }
        },
        async calculateHasItemsFlags() {
            if (this.portalNotFound) {
                this.hasFillableContentItems = false;
                this.hasContentItems = false;
                this.hasManagementInfoItems = false;
                return;
            }

            storeHelper.contentItemsStore
                .getHasContentItemsAsync(this.portalId, undefined, true)
                .then(result => (this.hasManagementInfoItems = result));

            this.hasFillableContentItems = await storeHelper.contentItemsStore.getHasContentItemsAsync(this.portalId, true, undefined);
            if (this.hasFillableContentItems) {
                //fillable items are also content items
                this.hasContentItems = true;
            } else {
                //check for content items items
                this.hasContentItems = await storeHelper.contentItemsStore.getHasContentItemsAsync(this.portalId);
            }
        },
        async loadFeatures() {
            const cachedFeatures = storeHelper.FeaturesStore.features;
            if (cachedFeatures && cachedFeatures.length > 0) {
                this.features = cachedFeatures;
                return;
            }
            this.features = await storeHelper.FeaturesStore.loadCurrentFeatures();
        }
    },
    watch: {
        portalId: {
            handler(newValue: number) {
                this.init();
            },
            immediate: true
        },
        showManageFavorites: async function () {
            if (!this.showManageFavorites) {
                await storeHelper.favoriteItemsStore.loadFavorites();
                this.setFavoriteItems();
            }
        },
        showReadDialog: function () {
            if (!this.showReadDialog) {
                this.closeNewsArticleDialog(false);
            }
        },
        showCreateDialog: function () {
            if (!this.showCreateDialog) {
                this.closeNewsArticleDialog(true);
            }
        },
        expandFavoritesPanel: {
            handler: async function () {
                UAS.set("expandFavoritesPanel", this.expandFavoritesPanel == 0 ? "0" : "-1");
                storeHelper.portalStore.setExpandFavoritesPanel(this.expandFavoritesPanel == 0 ? true : false);
            }
        },
        expandRecentPanel: {
            handler: async function () {
                UAS.set("expandRecentPanel", this.expandRecentPanel == 0 ? "0" : "-1");
                storeHelper.portalStore.setExpandRecentPanel(this.expandRecentPanel == 0 ? true : false);
            }
        },
        portalInformation: {
            immediate: true,
            handler(newValue) {
                if (newValue?.text) {
                    this.portalInformationText = newValue.text.replace(/href=".*?hyperlinkloader.aspx\?hyperlinkid=(.{36})"([^>]*>)/gi, function (
                        match,
                        $1,
                        $2
                    ) {
                        return 'href="#/hyperlink/' + $1 + '"' + $2;
                    });
                } else {
                    this.portalInformationText = null;
                }
            }
        }
    }
});
